module.exports = __webpack_public_path__ + "img/character2.fb75a350.png";